import keys from "../web-sh/src/config/keys";
export default {
  ...keys,
  AUTHENTICATE_APP: 'AUTHENTICATE_APP',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  CREATE_MASTER_PASSWORD: 'CREATE_MASTER_PASSWORD',
  SETUP_PASSWORDLESS: 'SETUP_PASSWORDLESS',
  PRIVATE_EMAIL: 'PRIVATE_EMAIL',
  SETTINGS_MEMBERS: 'SETTINGS_MEMBERS',
  SETTINGS_PLANS_BILLING: 'SETTINGS_PLANS_BILLING',
  REWARDS: 'REWARDS',
  MANAGE_PLANS: 'MANAGE_PLANS',
  WELCOME_TOUR: 'WELCOME_TOUR',
  SCAM_CHECKER: 'SCAM_CHECKER',
  CHECK_SCAM: 'CHECK_SCAM',
  SCAM_MY_REPORT: 'SCAM_MY_REPORT',
  SCAM_SETTING: 'SCAM_SETTING'
}